// extracted by mini-css-extract-plugin
export default {"root":"AnalyticList_root__N8TVd","item":"AnalyticList_item__-EieO"};